(function () {
  'use strict';

  angular
    .module('directive.back-to-top', [])

    .directive('backToTop', function () {
      return {
        restrict: 'A',
        controllerAs: 'backToTopCtrl',
        /* @ngInject */
        controller: ["$scope", "$window", function ($scope, $window) {
          var ctrl = this,
            lastPos;
          ctrl.active = false;

          $window.addEventListener('scroll', _.throttle(handler, 500));

          function handler() {
            var sc = isNaN(window.pageYOffset) ? document.documentElement.scrollTop : window.pageYOffset;
            $scope.$apply(function () {
              ctrl.active = sc > $window.innerHeight && sc < lastPos ? true : false;
            });
            lastPos = sc;
          }
        }]
      };

    });

})();
